import {Location, NgOptimizedImage} from '@angular/common';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {Injector, isDevMode, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {CookieService} from 'ngx-cookie-service';
import {getValueOrEmpty} from '../../../lib/dist/sdv-common';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {DealsComponent} from './deals/deals.component';
import {FooterComponent} from './footer/footer.component';
import {ForbiddenComponent} from './forbidden/forbidden.component';
import {HomeComponent} from './home/home.component';
import {MainComponent} from './main/main.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {OoopsComponent} from './ooops/ooops.component';
import {ProfileComponent} from './profile/profile.component';
import {ApiService} from './service/api.service';
import {setInjector} from './shared/constants';
import {SignInComponent} from './sign-in/sign-in.component';
import {SignUpComponent} from './sign-up/sign-up.component';
import {TopMenuComponent} from './top-menu/top-menu.component';
import {UserComponent} from './user/user.component';
import {DealComponent} from './deal/deal.component';
import {DropdownComponent} from './dropdown/dropdown.component';
import {ModalComponent} from './modal/modal.component';
import {WebSocketService} from './service/websocket.service';
import {SuccessfulComponent} from './successful/successful.component';
import {TokensComponent} from './tokens/tokens.component';
import {ServiceWorkerModule} from '@angular/service-worker';
import {OverviewComponent} from "./overview/overview.component";

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    HomeComponent,
    UserComponent,
    DealComponent,
    ModalComponent,
    OoopsComponent,
    DealsComponent,
    FooterComponent,
    SignInComponent,
    SignUpComponent,
    TokensComponent,
    TopMenuComponent,
    ProfileComponent,
    OverviewComponent,
    NotFoundComponent,
    DropdownComponent,
    ForbiddenComponent,
    SuccessfulComponent
  ],
  bootstrap: [AppComponent],
    imports: [
        FormsModule,
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
        NgOptimizedImage
    ],
  providers: [
    CookieService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {

  constructor(private apiService: ApiService,
              private webSocketService: WebSocketService,
              private location: Location,
              private injector: Injector) {
    setInjector(injector);

    window.onerror = (errorMessage, errorUrl, errorLine, column, errorObj) => {
      const options = {
        page: this.location.path(true),
        uri: ''
      };
      if (errorUrl) {
        options.uri = errorUrl;
      }
      const body = {
        projectId: '00000000-0000-0000-0000-000000000000',
        stackTraceType: 'JAVASCRIPT',
        stackTraceFormat: 'BASE64',
        source: 'Invest UI',
        alarmCode: 'ui',
        stack: '',
        options
      };
      const stack = getValueOrEmpty((errorObj || {stack: ''}).stack);
      if (stack.length > 0) {
        body.stack = btoa(unescape(encodeURIComponent(stack)));
      }
      const subscription = this.apiService.post('stat', body)
        .subscribe((res) => {
          subscription.unsubscribe();
        });
    };
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
